/** @format */
import styled from 'styled-components';

import { StyledVideoBlock } from '../video-block.styles';

// eslint-disable-next-line @mpb-com/mpb/no-exported-styled-component -- Legacy code: do not use as an example.
export const StyledVideoBlockSkeleton = styled(StyledVideoBlock)`
    .video-skeleton {
        width: 100%;
        height: 100%;
    }
`;
